import { defineStore } from 'pinia';
import api from '@api';
import { ref } from 'vue';
import { useAppStore } from './app.store';

/**
 * 用户认证相关
 * user: 用户信息
 * token: 用户token
 */
export const userAuthStore = defineStore(
  'auth.store',
  () => {
    const userInfo = ref({});
    const token = ref(null);
    const companyId = ref(null);
    const username = ref('');
    const rememberMe = ref(true);
    const isVerifiedAccessToken = ref(false);
    const cid = ref('');

    const _isCtrip = ref(false); // 是否是携程
    const _isTaimei = ref(false); // 是否是钛镁

    const setLoginInfo = ({ user: u, sessionToken: t }) => {
      userInfo.value = u;
      token.value = t;
      saveSessionToken(t);
    };

    function clear() {
      userInfo.value = null;
      token.value = '';
      cid.value = '';
      saveSessionToken('');
    }

    function isLogIn() {
      return !!token.value;
    }

    function setOrderUserInfo({ userRealName, idCard }) {
      userInfo.value.name = userRealName;
      userInfo.value.idCard = idCard;
    }

    function saveCID() {
      localStorage.setItem('__ci', cid.value);
    }

    function loadCID() {
      cid.value = localStorage.getItem('__ci');
    }

    function saveSessionToken(sessionToken) {
      isVerifiedAccessToken.value = true;
      localStorage.setItem('__st', sessionToken);
    }

    function getSessionToken() {
      return localStorage.getItem('__st');
    }

    function getToken() {
      let t = token.value;
      if (!t) {
        t = getSessionToken();
      }
      return t;
    }



    function autoLogin() {
      if (isVerifiedAccessToken.value) {
        return;
      }

      const sessionToken = getSessionToken();
      if (sessionToken) {
        token.value = sessionToken;
      }
    }

    function logout() {
      clear();
    }

    async function setCID(name) {
      switch (name) {
        case "ctrip":
          _isCtrip.value = true;
          // TODO
          cid.value = "";
          break;
        case "taimei":
          cid.value = "69fad82959a0094b9d47fb5d";
          _isTaimei.value = true;
          break;
        default:
          cid.value = "68bfbeef59a00946062c5ee9";
          break;
      }
      saveCID();
      try {
        const res = await api.getCompanySettings({});
        const { setSetting } = useAppStore();
        setSetting(res.setting);
      } catch (e) {
        console.error('获取公司设置失败:', e);
      }
    }

    function getCID() {
      if (!cid.value) {
        loadCID();
      }
      return cid.value;
    }

    // ------------------- 携程 开始-------------------
    function isCtrip() {
      return _isCtrip.value;
    }

    const loginCtrip = async (code) => {
      code = code.replaceAll(' ', '+');
      try {
        const res = await api.ctripLogin({
          data: code,
        });
        const { newUser, user: u, sessionToken: t } = res;
        if (!newUser) {
          setLoginInfo(res);
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error('注册失败:', error);
        clear();
        return false;
      }
    };
    // ------------------- 携程 结束-------------------


    // ------------------- 钛镁 开始-------------------
    function isTaimei() {
      return _isTaimei.value;
    }
    const loginTaimei = async (code) => {
      code = code.replaceAll(' ', '+');
      try {
        const res = await api.taimeiLogin({
          data: code,
        });
        // console.log('loginTaimei resp',res);
        setLoginInfo(res);
        return true

      } catch (error) {
        console.error('注册失败:', error);
        clear();
        return false;
      }
    };
    // ------------------- 钛镁 结束-------------------

    return {
      userInfo,
      getToken,
      username,
      rememberMe,
      isLogIn,
      clear,
      companyId,
      setLoginInfo,
      setOrderUserInfo,
      autoLogin,
      logout,
      setCID,
      getCID,

      isCtrip,
      loginCtrip,
      isTaimei,
      loginTaimei

    };
  },
  { persist: true }
);
